import React, { useState } from "react";
import { Link } from "react-router-dom";
import { secciones } from "../../datos";
import Copyright from "./CopyRight";
import { Suscriptor as SuscriptorAPI } from "../../api/suscriptor";

const suscriptorApi = new SuscriptorAPI();

function NewsletterForm() {
  const [email, setEmail]   = useState("");
  const [status, setStatus] = useState("idle"); // idle | loading | ok | error
  const [msg, setMsg]       = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setStatus("loading");
    try {
      await suscriptorApi.subscribe({ email: email.trim() });
      setStatus("ok");
      setEmail("");
    } catch (err) {
      setMsg(err?.message || "Ocurrió un error.");
      setStatus("error");
    }
  };

  if (status === "ok") {
    return <p className="text-green-400 text-xs font-medium mt-3">¡Te suscribiste! Recibirás nuestras novedades pronto.</p>;
  }

  return (
    <form onSubmit={handleSubmit} className="mt-3">
      <div className="flex gap-2">
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="tu@correo.com"
          className="flex-1 bg-white/10 border border-white/15 rounded-lg px-3 py-2 text-xs text-white placeholder-white/30 focus:outline-none focus:border-[#C81416] transition-colors"
        />
        <button
          type="submit"
          disabled={status === "loading"}
          className="px-3 py-2 bg-[#C81416] hover:bg-[#8c0e0f] disabled:opacity-60 rounded-lg text-white transition-colors flex-shrink-0"
        >
          {status === "loading" ? (
            <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
          ) : (
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M17 8l4 4m0 0l-4 4m4-4H3" />
            </svg>
          )}
        </button>
      </div>
      {status === "error" && <p className="text-red-400 text-xs mt-1.5">{msg}</p>}
    </form>
  );
}

export function Footer() {
  const { logo } = secciones[0].footer[0];

  return (
    <footer className="w-full bg-[#0d125c] text-white relative overflow-hidden">
      {/* Top accent line */}
      <div className="h-1 bg-gradient-to-r from-[#C81416] via-[#C81416]/80 to-[#151C84]" />

      {/* Background pattern */}
      <div
        className="absolute inset-0 opacity-[0.03] pointer-events-none"
        style={{
          backgroundImage: "radial-gradient(circle, white 1px, transparent 1px)",
          backgroundSize: "32px 32px",
        }}
      />

      {/* Decorative circles */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-[#C81416]/10 rounded-full translate-x-1/3 -translate-y-1/3 blur-3xl pointer-events-none" />
      <div className="absolute bottom-0 left-0 w-80 h-80 bg-[#151C84]/30 rounded-full -translate-x-1/3 translate-y-1/3 blur-3xl pointer-events-none" />

      {secciones[0].footer.map((item, index) => (
        <div className="container mx-auto px-4 py-16 relative z-10" key={index}>
          <div className="flex flex-col xl:flex-row text-center xl:text-left gap-y-12 xl:gap-y-0 xl:gap-x-16">

            {/* Brand column */}
            <div className="xl:w-1/3 flex flex-col items-center xl:items-start">
              <Link to="/" className="mb-6 inline-block group">
                <div className="transition-transform duration-300 group-hover:scale-105">
                  <img className="h-12 w-auto" src={logo} alt="Catelli Logo" />
                </div>
              </Link>
              <p className="text-white/55 text-sm leading-relaxed max-w-[280px] mb-5">
                {item.address}
              </p>
              <div className="flex flex-col gap-2 items-center xl:items-start">
                <a
                  href={`mailto:${item.email}`}
                  className="flex items-center gap-2 text-white/50 hover:text-white transition-colors text-sm group"
                >
                  <svg className="w-4 h-4 text-[#C81416] flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                  {item.email}
                </a>
                <a
                  href={`tel:${item.phone}`}
                  className="flex items-center gap-2 text-white/50 hover:text-white transition-colors text-sm"
                >
                  <svg className="w-4 h-4 text-[#C81416] flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                  </svg>
                  {item.phone}
                </a>
              </div>
            </div>

            {/* Links columns */}
            <div className="flex flex-1 flex-col gap-y-12 xl:flex-row justify-between xl:pl-16">
              {/* Interés */}
              <div className="xl:w-1/3">
                <h4 className="text-base font-bold mb-6 text-white relative pb-3">
                  Interés
                  <span className="absolute bottom-0 left-1/2 xl:left-0 -translate-x-1/2 xl:translate-x-0 w-10 h-0.5 bg-[#C81416] rounded-full" />
                </h4>
                <ul className="flex flex-col gap-y-3">
                  {item.list1?.map((link, i) => (
                    <li key={i}>
                      <Link
                        className="text-white/50 hover:text-white transition-all duration-200 text-sm hover:translate-x-1 inline-flex items-center gap-2 group"
                        to={link.href}
                      >
                        <span className="w-0 group-hover:w-2 h-0.5 bg-[#C81416] rounded-full transition-all duration-200 flex-shrink-0" />
                        {link.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Ayuda */}
              <div className="xl:w-1/3">
                <h4 className="text-base font-bold mb-6 text-white relative pb-3">
                  Ayuda
                  <span className="absolute bottom-0 left-1/2 xl:left-0 -translate-x-1/2 xl:translate-x-0 w-10 h-0.5 bg-[#C81416] rounded-full" />
                </h4>
                <ul className="flex flex-col gap-y-3">
                  {item.list2?.map((link, i) => (
                    <li key={i}>
                      <Link
                        className="text-white/50 hover:text-white transition-all duration-200 text-sm hover:translate-x-1 inline-flex items-center gap-2 group"
                        to={link.href}
                      >
                        <span className="w-0 group-hover:w-2 h-0.5 bg-[#C81416] rounded-full transition-all duration-200 flex-shrink-0" />
                        {link.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Redes Sociales */}
              <div className="xl:w-1/3">
                <h4 className="text-base font-bold mb-6 text-white relative pb-3">
                  Síguenos
                  <span className="absolute bottom-0 left-1/2 xl:left-0 -translate-x-1/2 xl:translate-x-0 w-10 h-0.5 bg-[#C81416] rounded-full" />
                </h4>
                <ul className="flex gap-3 justify-center xl:justify-start flex-wrap">
                  {item.socialList?.map((social, i) => (
                    <li key={i}>
                      <Link
                        className="w-11 h-11 bg-white/10 hover:bg-[#C81416] flex justify-center items-center rounded-xl cursor-pointer transition-all duration-300 hover:scale-110 hover:shadow-[0_4px_14px_rgba(200,20,22,0.45)] border border-white/10 hover:border-[#C81416] text-white text-lg"
                        to={social.href}
                        target="_blank"
                        rel="noreferrer"
                        title={social.name}
                      >
                        {social.icon}
                      </Link>
                    </li>
                  ))}
                </ul>

                {/* Newsletter mini */}
                <div className="mt-8">
                  <p className="text-white/50 text-xs">Recibe nuestras novedades</p>
                  <NewsletterForm />
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}

      {/* Bottom bar */}
      <div className="border-t border-white/10 relative z-10">
        <Copyright />
      </div>
    </footer>
  );
}
